
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("eMAdY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// ====================================================================================
// _template.module
// ====================================================================================
// import $ from "jquery";
// ====================================================================================
// CSS - Integrate directly into html
// ====================================================================================
var $ac31a5cd4a43d529$var$init = module.exports.init = function init() {
    var attempts = 0;
    // if document.ready needed
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") $ac31a5cd4a43d529$var$main();
        else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};
function $ac31a5cd4a43d529$var$main() {
    // #######################################################################################################
    // CCMOpener
    // #######################################################################################################
    document.querySelectorAll("li.CCMOpener > a").forEach(function(link) {
        link.addEventListener("click", function(e) {
            e.preventDefault(); // Verhindert das Standardverhalten (Seitenwechsel)
            if (typeof CCM !== "undefined" && typeof CCM.openWidget === "function") CCM.openWidget();
            else console.warn("CCM.openWidget() ist nicht definiert.");
        });
    });
}

});


//# sourceMappingURL=ccmOpener.module.53691939.js.map
